(function () {
    "use strict";

    // @ngInject
    function PayWallControllerCtor($scope, $injector, $modalInstance, $timeout, moment,
                                   AnalyticsService, OnboardingService, UiPersistenceService,
                                   pricingPlan, UserService, UsersManager) {
        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'PayWallController';
        this.AnalyticsService = AnalyticsService;
        this.AnalyticsService.trackPageView(this, 'paywall modal');
        this.OnboardingService = OnboardingService;

        this.modalInstance = $modalInstance;
        this.moment = moment;

        this.pushForDemo = !this.OnboardingService.isPaywallWithDiscount();
        this.pricingPlan = pricingPlan; // annual / monthly
        this.UserService = UserService;
        this.UsersManager = UsersManager;
        this.user = this.UsersManager.getCurrUser();
        this.UiPersistenceService = UiPersistenceService;

        this.refreshUserCalendlyData();
    }

    Controllers.PayWallController = Class(Controllers.BaseController, {
        constructor: PayWallControllerCtor,

        refreshUserCalendlyData: function refreshUserCalendlyData() {
            this.user.getCalendlyWalkthroughDate().then(function gotCalendlyWalkthroughDate() {
                this.scheduledAWalkthrough = this.user.calendly_scheduled_date;
                if (this.scheduledAWalkthrough) {
                    this.closeModal();
                }
            }.bind(this));
        },

        skipWall: function skipWall() {
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.skipPaywall, {dontShow: true});
            this.closeModal();
        },

        clickScheduleConsultation: function clickScheduleConsultation() {
            this.UserService.openAECalendlyLink(this.user, 'paywall modal', 'https://calendly.com/amanda-romero/30min');
            // this.closeOnboardingFlyoutPanel();
        },


        cancelModal: function cancelModal(){
            this.modalInstance.dismiss();
        },

        closeModal: function closeModal() {
            this.OnboardingService.cancelTempPaywallDiscount();
            this.OnboardingService.closePaywall();
            this.modalInstance.close();
        }
    });
}());
